import { memo } from "react";
import styles from "../../LoanRequestPage.module.scss";
import { OrderType } from "../../../../../model/orders/orders";
import moment from "moment";

type Props = {
	setOrderDetails: (value: OrderType | null) => void;
	data: OrderType[];
};

const DeclinedRequestTab = memo((props: Props) => {
	const { setOrderDetails, data } = props;

	return (
		<div className={styles.tableContainer}>
			<table className="standardTable">
				<thead>
					<tr>
						<th>CUSTMOER NAME</th>
						<th>LOAN AMOUNT</th>
						<th>APPROVAL STATUS</th>
						<th>REASON FOR REJECTION</th>
						<th>APPLICATION DATE</th>
						<th>ACTION</th>
					</tr>
				</thead>
				<tbody>
					{data?.map((item, index) => (
						<tr key={index}>
							<td>{item.customer?.firstName + " " + item.customer?.lastName}</td>
							<td>{item.costOverview.totalAmount.toLocaleString()}</td>
							<td className={styles.declined}>Declined</td>
							<td>{item?.description}</td>
							<td>{item.createdAt ? moment(item.createdAt).format("h:mm A MMM DD, YYYY") : "-"}</td>
							<td>
								<button className={`actionButton`} onClick={() => setOrderDetails(item)}>
									REVIEW
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
});

export default DeclinedRequestTab;
